import "./style.scss";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Autocomplete, Checkbox } from "@mui/material";
import FilterInput from "components/shared/FilterInput";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface IChannelSearch {
    /**
     * typed query to search
     */
    searchQuery: string;
    /**
     * change typed query state
     */
    onSearchQuery: (e: any) => void;
    /**
     * change current selected category by id
     */
    setCurrentCategory: React.Dispatch<SetStateAction<{ id: number; name: string } | null>>;
    /**
     * selected category on filter
     */
    currentCategory: { id: number; name: string } | null;
}

const ChannelsSearch = ({ searchQuery, onSearchQuery, setCurrentCategory, currentCategory }: IChannelSearch) => {
    const [t] = useTranslation();

    const renderInputSalesFormat = (params: any) => {
        return <StyledTextField {...params} placeholder={t("Filters.AllFeminine")} />;
    };

    const renderCategoryOptions = (props: any, option: any, state: any) => {
        const checked: boolean = option.id == currentCategory?.id;
        return (
            <li {...props} className="management-autocomplete-options" id={option.id}>
                <Checkbox
                    icon={<CheckBoxOutlineBlankIcon />}
                    checkedIcon={<CheckBoxIcon color="primary" />}
                    checked={checked}
                    size="small"
                    sx={{ opacity: 0.6 }}
                />
                <span style={{ fontSize: "13px", whiteSpace: "nowrap" }}>{option.name}</span>
            </li>
        );
    };

    const categoryOptions: any = [
        { id: 1, name: t("NewChannel.Physical") },
        { id: 2, name: t("NewChannel.Numerical") },
        { id: 3, name: t("NewChannel.RightTransfer") },
        { id: 4, name: t("NewChannel.AuthorAssociation") },
        { id: 5, name: t("Settings.Other") },
    ];

    const handleChangeCategory = (category: any) => {
        if (category) setCurrentCategory(category);
        else setCurrentCategory(null);
    };

    return (
        <div className="channels-list-search">
            <div className="channels-search-input">
                <FilterInput setFilterValue={onSearchQuery} filterValue={searchQuery} />
            </div>
            <div className="channels-filter">
                <label>{t("NewChannel.SalesFormat")}</label>
                <Autocomplete
                    onChange={(e, value) => handleChangeCategory(value)}
                    disableCloseOnSelect
                    options={categoryOptions}
                    renderInput={(params) => renderInputSalesFormat(params)}
                    renderOption={renderCategoryOptions}
                    getOptionLabel={(option) => option.name}
                    noOptionsText={t("AutocompleteForm.NoOptions")}
                    componentsProps={{
                        popper: { className: "autocomplete-form-component" },
                    }}
                    openOnFocus={true}
                />
            </div>
        </div>
    );
};

export default ChannelsSearch;
